import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, is } from 'immutable'
import TargetConditionInput from 'components/CampaignWizards/TargetingInputArea/TargetConditionInput'
import MultiSegmentSelect from 'components/CampaignWizards/TargetingInputArea/MultiSegmentSelect'
import { getChanges, getOrgSettingsFromEmbed } from 'components/Customize/OrgSettings/Helpers'
import { NotificationMessages } from 'components/Customize/Availability/Constants'
import { Audiences } from 'components/Customize/Audience/Helpers'
import ACCESS, { Gates } from 'utils/Access'

import style from './style.styl'

function updateAudience(initialOrgSettings, audience, index, value) {
  const orgSettings = initialOrgSettings.setIn(['theme', 'audience'], audience)

  if (audience === Audiences.SEGMENT.key) {
    if (!!value) {
      return orgSettings.setIn(['theme', 'userListIds', index], value)
    } else {
      return orgSettings.deleteIn(['theme', 'userListIds', index])
    }
  } else {
    return orgSettings.setIn(['theme', 'userListIds'], List())
  }
}

function maybeUnsetUserListIds(orgSettings) {
  const { userListIds, audience } = orgSettings.theme

  if (userListIds && audience !== Audiences.SEGMENT.key) {
    return orgSettings.removeIn(['theme', 'userListIds'])
  }
  return orgSettings
}

class Audience extends Component {
  static propTypes = {
    orgSettings: ImmutablePropTypes.recordOf({
      theme: ImmutablePropTypes.recordOf({
        userList: ImmutablePropTypes.listOf(PropTypes.number).isRequired,
        userListMode: PropTypes.string.isRequired,
        welcomeMessage: PropTypes.string.isRequired,
        emailCaptureMessage: PropTypes.string.isRequired,
      }).isRequired
    }).isRequired
  }

  static contextTypes = {
    app: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.onMultiSegmentSelected = this.onMultiSegmentSelected.bind(this)
  }

  onMultiSegmentSelected(newAudience, index, value) {
    const { embed, orgSettings } = this.props
    const initialOrgSettings = getOrgSettingsFromEmbed(embed)
    const updatedOrgSettings = updateAudience(orgSettings, newAudience, index, value)

    const shouldUpdate = !is(initialOrgSettings, updatedOrgSettings)

    if (shouldUpdate) this.updateMultiSegment(initialOrgSettings, updatedOrgSettings)
  }

  updateMultiSegment(initialOrgSettings, updatedOrgSettings) {
    const { actions } = this.context.app
    const changes = getChanges(maybeUnsetUserListIds(updatedOrgSettings), initialOrgSettings)

    actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings)
    actions.DefaultEmbedActions.patchDefaultEmbed(changes, NotificationMessages.TARGETING)
  }

  isPremium() {
    return ACCESS.hasGates(Gates.PREMIUM)
  }

  render() {
    const { segments, users, orgSettings } = this.props
    const { audience, userListIds } = orgSettings.theme

    return (
      <MultiSegmentSelect
        audience={audience}
        segments={segments}
        users={users}
        selectedSegments={userListIds}
        onSelection={this.onMultiSegmentSelected}
        isPremium={this.isPremium()}
        className={style.Segment}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    embed: state.get('embed').toJS().data,
  }
}

export default connect(mapStateToProps, null)(Audience)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/Segment/index.js